const ptBR = {
  metaTitle: 'Consultoria em TI | WSJ Soluções Digitais',
  badge: 'Consultoria em TI',
  heroTitle: 'Consultoria em TI para decisões mais seguras e sistemas mais eficientes.',
  heroSubtitle:
    'A WSJ ajuda empresas a organizar tecnologia, reduzir riscos e transformar problemas técnicos em soluções claras, escaláveis e bem planejadas.',
  heroBadges: [
    'Arquitetura de sistemas',
    'Diagnóstico técnico',
    'Processos digitais',
    'Automação',
    'Cloud',
    'Segurança',
    'Performance',
    'Integrações'
  ],
  btnQuote: 'Solicitar consultoria',
  btnWhatsapp: 'Falar no WhatsApp',
  btnPlans: 'Ver soluções',
  whatsappMessage: 'Olá! Gostaria de saber mais sobre consultoria em TI com a WSJ.',

  sectionProblemsTitle: 'Quando sua empresa precisa de consultoria em TI?',
  sectionProblemsClose: 'A consultoria certa evita desperdício, retrabalho e decisões caras.',
  problemItems: [
    { title: 'Sistemas lentos', desc: 'Operações que travam, demoram ou não acompanham o crescimento do negócio.' },
    { title: 'Processos manuais', desc: 'Tarefas repetitivas que consomem tempo e aumentam risco de erro.' },
    { title: 'Falta de integração', desc: 'Ferramentas isoladas sem comunicação entre sistemas e equipes.' },
    { title: 'Custos tecnológicos altos', desc: 'Gastos com ferramentas, servidores ou fornecedores sem clareza de retorno.' },
    { title: 'Decisões sem orientação técnica', desc: 'Investimentos em tecnologia sem base técnica ou planejamento.' },
    { title: 'Falta de segurança', desc: 'Riscos com acessos, backups, permissões e proteção de dados.' },
    { title: 'Projetos mal planejados', desc: 'Escopo confuso, prazos irrealistas e retrabalho evitável.' },
    { title: 'Equipe sem direção técnica', desc: 'Falta de referência para priorizar, decidir e evoluir sistemas.' }
  ],

  sectionHelpTitle: 'Consultoria prática para tecnologia funcionar melhor',
  sectionHelpLead: 'Da análise inicial ao acompanhamento estratégico — orientação técnica com foco em resultado.',
  helpItems: [
    { title: 'Diagnóstico técnico', desc: 'Análise do cenário atual, gargalos e oportunidades de melhoria.' },
    { title: 'Planejamento de sistemas', desc: 'Roadmap claro para evoluir software, processos e integrações.' },
    { title: 'Arquitetura de software', desc: 'Estrutura técnica pensada para escala, manutenção e crescimento.' },
    { title: 'Revisão de processos', desc: 'Mapeamento e organização de fluxos digitais e operacionais.' },
    { title: 'Escolha de tecnologias', desc: 'Orientação para selecionar ferramentas adequadas ao negócio.' },
    { title: 'Integração de ferramentas', desc: 'Conexão entre sistemas, APIs e plataformas existentes.' },
    { title: 'Automação de tarefas', desc: 'Identificação de rotinas que podem ser automatizadas.' },
    { title: 'Otimização de performance', desc: 'Melhorias em velocidade, estabilidade e eficiência técnica.' },
    { title: 'Apoio em cloud', desc: 'Orientação sobre hospedagem, servidores e estrutura na nuvem.' },
    { title: 'Segurança básica', desc: 'Boas práticas para reduzir riscos e proteger a operação.' },
    { title: 'Documentação técnica', desc: 'Registro claro de decisões, arquitetura e processos.' },
    { title: 'Suporte estratégico', desc: 'Acompanhamento consultivo para decisões técnicas contínuas.' }
  ],

  sectionAreasTitle: 'Atuação em diferentes necessidades de TI',
  sectionAreasLead: 'Consultoria aplicada conforme o desafio — do sistema interno à infraestrutura.',
  areas: [
    {
      title: 'Sistemas e software',
      desc: 'Análise, melhorias, arquitetura, integrações e planejamento de sistemas web, mobile e internos.'
    },
    {
      title: 'Automação e produtividade',
      desc: 'Identificação de tarefas repetitivas e criação de soluções digitais para reduzir trabalho manual.'
    },
    {
      title: 'Infraestrutura e cloud',
      desc: 'Apoio na escolha de hospedagem, servidores, bancos de dados, custos e estrutura técnica.'
    },
    {
      title: 'Segurança e organização',
      desc: 'Orientação para reduzir riscos, organizar acessos, backups, permissões e boas práticas.'
    }
  ],

  sectionProcessTitle: 'Processo de consultoria',
  sectionProcessLead: 'Um caminho claro do diagnóstico à implementação — com transparência em cada etapa.',
  processSteps: [
    { title: 'Entendemos o cenário atual', desc: 'Mapeamos sistemas, processos, equipe e objetivos do negócio.' },
    { title: 'Identificamos riscos e gargalos', desc: 'Diagnóstico técnico com foco em problemas reais e prioridades.' },
    { title: 'Propomos soluções viáveis', desc: 'Alternativas claras, com prós, contras e estimativas realistas.' },
    { title: 'Organizamos um plano técnico', desc: 'Roadmap com etapas, responsabilidades e próximos passos.' },
    { title: 'Acompanhamos a implementação', desc: 'Apoio consultivo durante execução, ajustes e evolução.' }
  ],

  sectionPlansTitle: 'Planos de consultoria em TI',
  sectionPlansLead: 'Do diagnóstico inicial ao acompanhamento estratégico — estrutura profissional com transparência.',
  plansBillingMonthly: 'Mensal',
  plansBillingAnnual: 'Anual',
  plansSaveBadge: 'Economize 17%',
  plansDisclaimer:
    'Os planos de consultoria não incluem desenvolvimento de software, aquisição de ferramentas, licenças, servidores, serviços externos ou contratação de terceiros, salvo quando especificado em proposta.',
  plansDisclaimerExtra:
    'Projetos com implementação técnica, desenvolvimento, automação, integrações, cloud ou suporte operacional contínuo podem exigir orçamento separado.',
  planStartName: 'TI Start',
  planStartDesc: 'Ideal para pequenas empresas que precisam de orientação técnica inicial.',
  planStartFeatures: [
    'Diagnóstico técnico inicial',
    '1 reunião mensal',
    'Orientação por email',
    'Análise de processos digitais',
    'Recomendações técnicas',
    'Plano básico de melhorias',
    'Suporte consultivo básico'
  ],
  planStartCta: 'Começar consultoria',
  planGrowthName: 'TI Growth',
  planGrowthBadge: 'Mais popular',
  planGrowthDesc: 'Ideal para empresas que precisam de acompanhamento técnico contínuo.',
  planGrowthFeatures: [
    'Tudo do Start',
    '2 reuniões mensais',
    'Diagnóstico contínuo',
    'Apoio em decisões técnicas',
    'Planejamento de sistemas',
    'Análise de fornecedores',
    'Organização de processos',
    'Relatório mensal',
    'Suporte prioritário'
  ],
  planGrowthCta: 'Começar agora',
  planPremiumName: 'TI Premium',
  planPremiumBadge: 'Premium',
  planPremiumDesc:
    'Ideal para empresas com projetos críticos, sistemas complexos ou necessidade de acompanhamento estratégico.',
  planPremiumFeatures: [
    'Consultoria estratégica',
    'Acompanhamento próximo',
    'Revisão de arquitetura',
    'Apoio em projetos críticos',
    'Análise de segurança',
    'Planejamento de integrações',
    'Consultoria para cloud',
    'Documentação técnica',
    'Atendimento dedicado',
    'SLA prioritário'
  ],
  planPremiumCta: 'Falar com especialista',

  sectionRealProjectsTitle: 'Experiência aplicada em projetos digitais reais',
  sectionRealProjectsLead:
    'A WSJ une desenvolvimento, automação, e-commerce e consultoria para apoiar empresas em decisões tecnológicas.',
  realProjectsNote:
    'Projetos reais entregues pela WSJ demonstram experiência prática em sistemas, integrações e operação digital.',
  realProjectsVisitCta: 'Conhecer projeto',
  realProjectBadgeInstitutional: 'Institucional',
  realProjectBadgeEcommerce: 'E-commerce',
  realProjectBadgeProduct: 'Produto WSJ',
  realProjects: [
    {
      name: 'WSJ Pedidos',
      url: '/wsj-pedidos',
      category: 'Operação digital',
      badge: 'product',
      desc: 'Plataforma de pedidos e atendimento digital desenvolvida pela WSJ para operações reais.',
      logo: '/wsj-logo.png',
      previewGradient: 'from-sky-600/30 via-indigo-900/15 to-slate-950/50'
    },
    {
      name: 'BENCOAÇO',
      url: 'https://bencoaco.com.br/',
      category: 'Presença digital',
      badge: 'institutional',
      desc: 'Projeto digital profissional com foco em autoridade, branding e operação online.',
      logo: '/assets/clients/bencoaco.png',
      previewGradient: 'from-blue-600/30 via-sky-900/15 to-slate-950/50'
    },
    {
      name: 'SOETO',
      url: 'https://www.soeto.com.br/',
      category: 'Operação digital',
      badge: 'ecommerce',
      desc: 'Estrutura digital completa com catálogo, experiência do usuário e profissionalismo.',
      logo: '/assets/clients/soeto.png',
      previewGradient: 'from-emerald-600/28 via-green-900/15 to-slate-950/50'
    },
    {
      name: 'CAFEGHINI',
      url: 'https://www.cafeghini.com.br/',
      category: 'Branding digital',
      badge: 'ecommerce',
      desc: 'Presença digital moderna com identidade visual premium e navegação profissional.',
      logo: '/assets/clients/cafeghini.png',
      previewGradient: 'from-rose-600/30 via-red-900/15 to-slate-950/50'
    }
  ],

  sectionFaqTitle: 'Perguntas frequentes',
  sectionFaqLead: 'Transparência total antes de contratar consultoria em TI.',
  faqItems: [
    {
      q: 'A consultoria inclui desenvolvimento?',
      a: 'Não por padrão. Os planos de consultoria focam em diagnóstico, orientação e planejamento. Desenvolvimento, implementação e serviços operacionais são orçados separadamente quando necessário.'
    },
    {
      q: 'Vocês ajudam a escolher tecnologia?',
      a: 'Sim. Analisamos necessidades, orçamento e contexto do negócio para recomendar tecnologias e ferramentas adequadas.'
    },
    {
      q: 'Vocês analisam sistemas existentes?',
      a: 'Sim. Fazemos diagnóstico de sistemas, integrações, performance, segurança e processos digitais já em uso.'
    },
    {
      q: 'Posso contratar apenas uma orientação inicial?',
      a: 'Sim. O plano TI Start é ideal para uma orientação técnica inicial com diagnóstico e recomendações básicas.'
    },
    {
      q: 'Vocês ajudam com cloud e hospedagem?',
      a: 'Sim. Orientamos sobre estrutura de servidores, cloud, bancos de dados e custos — sem incluir contratação de infraestrutura nos planos.'
    },
    {
      q: 'A consultoria inclui suporte técnico?',
      a: 'Inclui suporte consultivo conforme plano — orientação, análise e acompanhamento. Suporte operacional contínuo pode exigir proposta separada.'
    },
    {
      q: 'Vocês fazem documentação?',
      a: 'Sim. Planos avançados incluem documentação técnica de arquitetura, processos e decisões relevantes.'
    },
    {
      q: 'Posso evoluir da consultoria para um projeto completo?',
      a: 'Sim. Muitos clientes iniciam com consultoria e evoluem para desenvolvimento, automação ou integrações com escopo definido em proposta.'
    }
  ],

  finalCtaTitle: 'Precisa tomar decisões melhores em tecnologia?',
  finalCtaSubtitle:
    'A WSJ ajuda sua empresa a transformar dúvidas técnicas em um plano claro, profissional e viável.',

  heroMock: {
    dashboardLabel: 'Dashboard técnico',
    architectureLabel: 'Arquitetura',
    performanceLabel: 'Performance',
    securityLabel: 'Segurança',
    processLabel: 'Mapa de processos',
    integrationsLabel: 'Integrações conectadas'
  }
};

const ptPT = {
  ...ptBR,
  metaTitle: 'Consultoria em TI | WSJ Soluções Digitais',
  badge: 'Consultoria em TI',
  heroTitle: 'Consultoria em TI para decisões mais seguras e sistemas mais eficientes.',
  heroSubtitle:
    'A WSJ ajuda empresas a organizar tecnologia, reduzir riscos e transformar problemas técnicos em soluções claras, escaláveis e bem planeadas.',
  btnQuote: 'Solicitar consultoria',
  btnWhatsapp: 'Falar no WhatsApp',
  whatsappMessage: 'Olá! Gostaria de saber mais sobre consultoria em TI com a WSJ.',

  sectionProblemsTitle: 'Quando a sua empresa precisa de consultoria em TI?',
  problemItems: [
    { title: 'Sistemas lentos', desc: 'Operações que travam, demoram ou não acompanham o crescimento do negócio.' },
    { title: 'Processos manuais', desc: 'Tarefas repetitivas que consomem tempo e aumentam risco de erro.' },
    { title: 'Falta de integração', desc: 'Ferramentas isoladas sem comunicação entre sistemas e equipas.' },
    { title: 'Custos tecnológicos elevados', desc: 'Gastos com ferramentas, servidores ou fornecedores sem clareza de retorno.' },
    { title: 'Decisões sem orientação técnica', desc: 'Investimentos em tecnologia sem base técnica ou planeamento.' },
    { title: 'Falta de segurança', desc: 'Riscos com acessos, backups, permissões e proteção de dados.' },
    { title: 'Projetos mal planeados', desc: 'Âmbito confuso, prazos irrealistas e retrabalho evitável.' },
    { title: 'Equipa sem direção técnica', desc: 'Falta de referência para priorizar, decidir e evoluir sistemas.' }
  ],

  sectionHelpLead: 'Da análise inicial ao acompanhamento estratégico — orientação técnica com foco em resultado.',
  helpItems: [
    { title: 'Diagnóstico técnico', desc: 'Análise do cenário atual, gargalos e oportunidades de melhoria.' },
    { title: 'Planeamento de sistemas', desc: 'Roadmap claro para evoluir software, processos e integrações.' },
    { title: 'Arquitetura de software', desc: 'Estrutura técnica pensada para escala, manutenção e crescimento.' },
    { title: 'Revisão de processos', desc: 'Mapeamento e organização de fluxos digitais e operacionais.' },
    { title: 'Escolha de tecnologias', desc: 'Orientação para selecionar ferramentas adequadas ao negócio.' },
    { title: 'Integração de ferramentas', desc: 'Ligação entre sistemas, APIs e plataformas existentes.' },
    { title: 'Automatização de tarefas', desc: 'Identificação de rotinas que podem ser automatizadas.' },
    { title: 'Otimização de performance', desc: 'Melhorias em velocidade, estabilidade e eficiência técnica.' },
    { title: 'Apoio em cloud', desc: 'Orientação sobre alojamento, servidores e estrutura na nuvem.' },
    { title: 'Segurança básica', desc: 'Boas práticas para reduzir riscos e proteger a operação.' },
    { title: 'Documentação técnica', desc: 'Registo claro de decisões, arquitetura e processos.' },
    { title: 'Suporte estratégico', desc: 'Acompanhamento consultivo para decisões técnicas contínuas.' }
  ],

  areas: [
    {
      title: 'Sistemas e software',
      desc: 'Análise, melhorias, arquitetura, integrações e planeamento de sistemas web, mobile e internos.'
    },
    {
      title: 'Automatização e produtividade',
      desc: 'Identificação de tarefas repetitivas e criação de soluções digitais para reduzir trabalho manual.'
    },
    {
      title: 'Infraestrutura e cloud',
      desc: 'Apoio na escolha de alojamento, servidores, bases de dados, custos e estrutura técnica.'
    },
    {
      title: 'Segurança e organização',
      desc: 'Orientação para reduzir riscos, organizar acessos, backups, permissões e boas práticas.'
    }
  ],

  sectionProcessLead: 'Um caminho claro do diagnóstico à implementação — com transparência em cada etapa.',
  processSteps: [
    { title: 'Compreendemos o cenário atual', desc: 'Mapeamos sistemas, processos, equipa e objetivos do negócio.' },
    { title: 'Identificamos riscos e gargalos', desc: 'Diagnóstico técnico com foco em problemas reais e prioridades.' },
    { title: 'Propomos soluções viáveis', desc: 'Alternativas claras, com prós, contras e estimativas realistas.' },
    { title: 'Organizamos um plano técnico', desc: 'Roadmap com etapas, responsabilidades e próximos passos.' },
    { title: 'Acompanhamos a implementação', desc: 'Apoio consultivo durante execução, ajustes e evolução.' }
  ],

  plansDisclaimerExtra:
    'Projetos com implementação técnica, desenvolvimento, automatização, integrações, cloud ou suporte operacional contínuo podem exigir orçamento separado.',

  realProjects: [
    {
      name: 'WSJ Pedidos',
      url: '/wsj-pedidos',
      category: 'Operação digital',
      badge: 'product',
      desc: 'Plataforma de pedidos e atendimento digital desenvolvida pela WSJ para operações reais.',
      logo: '/wsj-logo.png',
      previewGradient: 'from-sky-600/30 via-indigo-900/15 to-slate-950/50'
    },
    {
      name: 'BENCOAÇO',
      url: 'https://bencoaco.com.br/',
      category: 'Presença digital',
      badge: 'institutional',
      desc: 'Projeto digital profissional com foco em autoridade, branding e operação online.',
      logo: '/assets/clients/bencoaco.png',
      previewGradient: 'from-blue-600/30 via-sky-900/15 to-slate-950/50'
    },
    {
      name: 'SOETO',
      url: 'https://www.soeto.com.br/',
      category: 'Operação digital',
      badge: 'ecommerce',
      desc: 'Estrutura digital completa com catálogo, experiência do utilizador e profissionalismo.',
      logo: '/assets/clients/soeto.png',
      previewGradient: 'from-emerald-600/28 via-green-900/15 to-slate-950/50'
    },
    {
      name: 'CAFEGHINI',
      url: 'https://www.cafeghini.com.br/',
      category: 'Branding digital',
      badge: 'ecommerce',
      desc: 'Presença digital moderna com identidade visual premium e navegação profissional.',
      logo: '/assets/clients/cafeghini.png',
      previewGradient: 'from-rose-600/30 via-red-900/15 to-slate-950/50'
    }
  ],

  faqItems: [
    { q: 'A consultoria inclui desenvolvimento?', a: 'Não por defeito. Os planos de consultoria focam em diagnóstico, orientação e planeamento. Desenvolvimento, implementação e serviços operacionais são orçados separadamente quando necessário.' },
    { q: 'Ajudam a escolher tecnologia?', a: 'Sim. Analisamos necessidades, orçamento e contexto do negócio para recomendar tecnologias e ferramentas adequadas.' },
    { q: 'Analisam sistemas existentes?', a: 'Sim. Fazemos diagnóstico de sistemas, integrações, performance, segurança e processos digitais já em uso.' },
    { q: 'Posso contratar apenas uma orientação inicial?', a: 'Sim. O plano TI Start é ideal para uma orientação técnica inicial com diagnóstico e recomendações básicas.' },
    { q: 'Ajudam com cloud e alojamento?', a: 'Sim. Orientamos sobre estrutura de servidores, cloud, bases de dados e custos — sem incluir contratação de infraestrutura nos planos.' },
    { q: 'A consultoria inclui suporte técnico?', a: 'Inclui suporte consultivo conforme plano — orientação, análise e acompanhamento. Suporte operacional contínuo pode exigir proposta separada.' },
    { q: 'Fazem documentação?', a: 'Sim. Planos avançados incluem documentação técnica de arquitetura, processos e decisões relevantes.' },
    { q: 'Posso evoluir da consultoria para um projeto completo?', a: 'Sim. Muitos clientes iniciam com consultoria e evoluem para desenvolvimento, automatização ou integrações com âmbito definido em proposta.' }
  ],

  finalCtaSubtitle:
    'A WSJ ajuda a sua empresa a transformar dúvidas técnicas num plano claro, profissional e viável.'
};

const enUS = {
  metaTitle: 'IT Consulting | WSJ Soluções Digitais',
  badge: 'IT Consulting',
  heroTitle: 'IT consulting for safer decisions and more efficient systems.',
  heroSubtitle:
    'WSJ helps businesses organise technology, reduce risks and turn technical problems into clear, scalable and well-planned solutions.',
  heroBadges: [
    'System architecture',
    'Technical diagnosis',
    'Digital processes',
    'Automation',
    'Cloud',
    'Security',
    'Performance',
    'Integrations'
  ],
  btnQuote: 'Request consulting',
  btnWhatsapp: 'Talk on WhatsApp',
  btnPlans: 'View solutions',
  whatsappMessage: 'Hello! I would like to know more about IT consulting with WSJ.',

  sectionProblemsTitle: 'When does your business need IT consulting?',
  sectionProblemsClose: 'The right consulting avoids waste, rework and expensive decisions.',
  problemItems: [
    { title: 'Slow systems', desc: 'Operations that freeze, lag or cannot keep up with business growth.' },
    { title: 'Manual processes', desc: 'Repetitive tasks that consume time and increase error risk.' },
    { title: 'Lack of integration', desc: 'Isolated tools with no communication between systems and teams.' },
    { title: 'High technology costs', desc: 'Spending on tools, servers or vendors without clear return.' },
    { title: 'Decisions without technical guidance', desc: 'Technology investments without technical basis or planning.' },
    { title: 'Lack of security', desc: 'Risks with access, backups, permissions and data protection.' },
    { title: 'Poorly planned projects', desc: 'Unclear scope, unrealistic timelines and avoidable rework.' },
    { title: 'Team without technical direction', desc: 'No reference to prioritise, decide and evolve systems.' }
  ],

  sectionHelpTitle: 'Practical consulting for better technology',
  sectionHelpLead: 'From initial analysis to strategic follow-up — technical guidance focused on results.',
  helpItems: [
    { title: 'Technical diagnosis', desc: 'Analysis of current scenario, bottlenecks and improvement opportunities.' },
    { title: 'System planning', desc: 'Clear roadmap to evolve software, processes and integrations.' },
    { title: 'Software architecture', desc: 'Technical structure designed for scale, maintenance and growth.' },
    { title: 'Process review', desc: 'Mapping and organisation of digital and operational flows.' },
    { title: 'Technology selection', desc: 'Guidance to choose tools suited to the business.' },
    { title: 'Tool integration', desc: 'Connection between systems, APIs and existing platforms.' },
    { title: 'Task automation', desc: 'Identification of routines that can be automated.' },
    { title: 'Performance optimisation', desc: 'Improvements in speed, stability and technical efficiency.' },
    { title: 'Cloud support', desc: 'Guidance on hosting, servers and cloud infrastructure.' },
    { title: 'Basic security', desc: 'Best practices to reduce risks and protect operations.' },
    { title: 'Technical documentation', desc: 'Clear record of decisions, architecture and processes.' },
    { title: 'Strategic support', desc: 'Consultative follow-up for ongoing technical decisions.' }
  ],

  sectionAreasTitle: 'Coverage for different IT needs',
  sectionAreasLead: 'Consulting applied to each challenge — from internal systems to infrastructure.',
  areas: [
    {
      title: 'Systems & software',
      desc: 'Analysis, improvements, architecture, integrations and planning for web, mobile and internal systems.'
    },
    {
      title: 'Automation & productivity',
      desc: 'Identification of repetitive tasks and digital solutions to reduce manual work.'
    },
    {
      title: 'Infrastructure & cloud',
      desc: 'Support in choosing hosting, servers, databases, costs and technical structure.'
    },
    {
      title: 'Security & organisation',
      desc: 'Guidance to reduce risks, organise access, backups, permissions and best practices.'
    }
  ],

  sectionProcessTitle: 'Consulting process',
  sectionProcessLead: 'A clear path from diagnosis to implementation — with transparency at every stage.',
  processSteps: [
    { title: 'We understand the current scenario', desc: 'We map systems, processes, team and business goals.' },
    { title: 'We identify risks and bottlenecks', desc: 'Technical diagnosis focused on real problems and priorities.' },
    { title: 'We propose viable solutions', desc: 'Clear alternatives with pros, cons and realistic estimates.' },
    { title: 'We organise a technical plan', desc: 'Roadmap with steps, responsibilities and next actions.' },
    { title: 'We support implementation', desc: 'Consultative support during execution, adjustments and evolution.' }
  ],

  sectionPlansTitle: 'IT consulting plans',
  sectionPlansLead: 'From initial diagnosis to strategic follow-up — professional structure with transparency.',
  plansBillingMonthly: 'Monthly',
  plansBillingAnnual: 'Annual',
  plansSaveBadge: 'Save 17%',
  plansDisclaimer:
    'Consulting plans do not include software development, tool purchases, licences, servers, external services or third-party hiring unless specified in the proposal.',
  plansDisclaimerExtra:
    'Projects with technical implementation, development, automation, integrations, cloud or continuous operational support may require a separate quote.',
  planStartName: 'IT Start',
  planStartDesc: 'Ideal for small businesses that need initial technical guidance.',
  planStartFeatures: [
    'Initial technical diagnosis',
    '1 monthly meeting',
    'Email guidance',
    'Digital process analysis',
    'Technical recommendations',
    'Basic improvement plan',
    'Basic consultative support'
  ],
  planStartCta: 'Start consulting',
  planGrowthName: 'IT Growth',
  planGrowthBadge: 'Most popular',
  planGrowthDesc: 'Ideal for businesses that need continuous technical follow-up.',
  planGrowthFeatures: [
    'Everything in Start',
    '2 monthly meetings',
    'Continuous diagnosis',
    'Support in technical decisions',
    'System planning',
    'Vendor analysis',
    'Process organisation',
    'Monthly report',
    'Priority support'
  ],
  planGrowthCta: 'Get started',
  planPremiumName: 'IT Premium',
  planPremiumBadge: 'Premium',
  planPremiumDesc: 'Ideal for businesses with critical projects, complex systems or strategic follow-up needs.',
  planPremiumFeatures: [
    'Strategic consulting',
    'Close follow-up',
    'Architecture review',
    'Critical project support',
    'Security analysis',
    'Integration planning',
    'Cloud consulting',
    'Technical documentation',
    'Dedicated account manager',
    'Priority SLA'
  ],
  planPremiumCta: 'Talk to a specialist',

  sectionRealProjectsTitle: 'Experience applied to real digital projects',
  sectionRealProjectsLead:
    'WSJ combines development, automation, e-commerce and consulting to support businesses in technology decisions.',
  realProjectsNote: 'Real projects delivered by WSJ demonstrate practical experience in systems, integrations and digital operations.',
  realProjectsVisitCta: 'View project',
  realProjectBadgeInstitutional: 'Corporate',
  realProjectBadgeEcommerce: 'E-commerce',
  realProjectBadgeProduct: 'WSJ Product',
  realProjects: [
    {
      name: 'WSJ Pedidos',
      url: '/wsj-pedidos',
      category: 'Digital operation',
      badge: 'product',
      desc: 'Orders and digital support platform built by WSJ for real operations.',
      logo: '/wsj-logo.png',
      previewGradient: 'from-sky-600/30 via-indigo-900/15 to-slate-950/50'
    },
    {
      name: 'BENCOAÇO',
      url: 'https://bencoaco.com.br/',
      category: 'Digital presence',
      badge: 'institutional',
      desc: 'Professional digital project focused on authority, branding and online operation.',
      logo: '/assets/clients/bencoaco.png',
      previewGradient: 'from-blue-600/30 via-sky-900/15 to-slate-950/50'
    },
    {
      name: 'SOETO',
      url: 'https://www.soeto.com.br/',
      category: 'Digital operation',
      badge: 'ecommerce',
      desc: 'Complete digital structure with catalogue, user experience and professionalism.',
      logo: '/assets/clients/soeto.png',
      previewGradient: 'from-emerald-600/28 via-green-900/15 to-slate-950/50'
    },
    {
      name: 'CAFEGHINI',
      url: 'https://www.cafeghini.com.br/',
      category: 'Digital branding',
      badge: 'ecommerce',
      desc: 'Modern digital presence with premium visual identity and professional navigation.',
      logo: '/assets/clients/cafeghini.png',
      previewGradient: 'from-rose-600/30 via-red-900/15 to-slate-950/50'
    }
  ],

  sectionFaqTitle: 'FAQ',
  sectionFaqLead: 'Full transparency before you hire IT consulting.',
  faqItems: [
    { q: 'Does consulting include development?', a: 'Not by default. Consulting plans focus on diagnosis, guidance and planning. Development, implementation and operational services are quoted separately when needed.' },
    { q: 'Do you help choose technology?', a: 'Yes. We analyse needs, budget and business context to recommend suitable technologies and tools.' },
    { q: 'Do you analyse existing systems?', a: 'Yes. We diagnose systems, integrations, performance, security and digital processes already in use.' },
    { q: 'Can I hire only initial guidance?', a: 'Yes. The IT Start plan is ideal for initial technical guidance with diagnosis and basic recommendations.' },
    { q: 'Do you help with cloud and hosting?', a: 'Yes. We guide on server structure, cloud, databases and costs — without including infrastructure hiring in plans.' },
    { q: 'Does consulting include technical support?', a: 'It includes consultative support according to plan — guidance, analysis and follow-up. Continuous operational support may require a separate proposal.' },
    { q: 'Do you provide documentation?', a: 'Yes. Advanced plans include technical documentation of architecture, processes and relevant decisions.' },
    { q: 'Can I evolve from consulting to a full project?', a: 'Yes. Many clients start with consulting and evolve to development, automation or integrations with scope defined in a proposal.' }
  ],

  finalCtaTitle: 'Need to make better technology decisions?',
  finalCtaSubtitle: 'WSJ helps your business turn technical doubts into a clear, professional and viable plan.',

  heroMock: {
    dashboardLabel: 'Technical dashboard',
    architectureLabel: 'Architecture',
    performanceLabel: 'Performance',
    securityLabel: 'Security',
    processLabel: 'Process map',
    integrationsLabel: 'Connected integrations'
  }
};

const fallbackLocales = ['es', 'fr', 'it', 'hi', 'de', 'nl', 'ru', 'ar', 'zh-CN', 'zh-TW'];

export const itConsultingPageByLang = {
  'pt-BR': ptBR,
  'pt-PT': ptPT,
  en: enUS,
  ...Object.fromEntries(fallbackLocales.map((code) => [code, enUS]))
};
